<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle />
        <b-card v-if="!loading">
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="consentModel">{{ $t('informedConsent.consentModels') }}
                  <required-field/>
                </label>
                <v-select id="consentModel" v-model="consentModel" :options="models" :getOptionLabel="getParsedModels"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="region">{{ $t('informedConsent.regionLabel') }}
                  <required-field/>
                </label>
                <v-select id="region" v-model="informedConsent.region" :options="regions" index="code"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="informationModel">{{ $t('informedConsent.informationModels') }}
                  <required-field/>
                </label>
                <v-select id="informationModel" v-model="informationModel" :options="models" :getOptionLabel="getParsedModels"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="updateInformedConsent">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'informationConsentsListRoute'}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from "mini-toastr";
import PageTitle from "../../components/PageTitle";
import i18n from '@/config/i18n'
import moment from "moment";
import InformationConsentService from "../../services/InformationConsentService";
import RequiredField from "../../components/RequiredField";
import vSelect from "vue-select";
const informationConsentService = InformationConsentService.build();
import ModelService from "@/services/ModelService";
import RegionService from "@/services/RegionService";
const modelService = ModelService.build();
const regionService = RegionService.build();

export default {
  name: "InformedConsentEdit",
  components: {
    PageTitle,
    RequiredField,
    vSelect,
  },
  props: {
    id: {
      required: true
    }
  },
  data() {
    return {
      informedConsent: {
        validityStartDate: new Date(),
        consentModel: null,
        region: null,
        informationModel: null
      },
      informationModel: null,
      consentModel : null,
      loading: true,
      models: [],
      regions: []
    }
  },
  created() {
    miniToastr.init();
    miniToastr.setIcon('info', 'i', {'class': 'fas fa-info-circle'});
    this.fetchData()
    this.getModels()
    this.getRegions()
  },
  methods: {
    status (status = 'unknown') {
      return i18n.t(`pendingConsent.status.${status}`)
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    async fetchData() {
      this.loading = true;

      try {
        const consent = await informationConsentService.read(this.id)
        this.informedConsent = {
          validityStartDate: consent.validityStartDate,
          consentModel: consent.consentModelCode,
          region:  consent.regionCode,
          informationModel: consent.informationModelCode,
        }
        this.informationModel= (await modelService.fetchByCode(this.informedConsent.informationModel));
        this.consentModel= (await modelService.fetchByCode(this.informedConsent.consentModel));
      } catch (exception) {
        console.error(exception)
        exception.errors.forEach(function (element) {
          miniToastr.error(element.message);
        });
      } finally {
        this.loading = false;
      }
    },
    async updateInformedConsent() {
      try {
        await informationConsentService.update(
          {
            id: this.id,
            regionCode: this.informedConsent.region,
            consentModelCode: this.consentModel ? this.consentModel.code : '',
            validityStartDate: new Date(),
            informationModelCode: this.informationModel ? this.informationModel.code : '',
          })
        this.$router.push({name: 'informationConsentsShowRoute', params: {id: this.id}})
        miniToastr.info("Consenso informato aggiornato con successo");
      } catch (exception) {
        if (exception.errors){
          this.errors = exception.errors
          exception.errors.forEach(function (element) {
            miniToastr.error(element.message);
          });
        }else{
          this.errors = exception.message
          miniToastr.error(this.errors);
        }
      }
    },
    async getModels() {
       this.models = (await modelService.search({ max: -1 })).data;
    },
    async getRegions() {
      this.regions = (await regionService.search({ max: -1 })).regions;
    },
    getParsedModels(model) {
      return `${model.description} (ID: ${model.code})`
    },
  }
}
</script>
